import React from 'react';
import { motion } from 'framer-motion';
export function StatBlock() {
  return <section className="py-6 px-4 bg-white" data-id="element-432">
      <div className="max-w-3xl mx-auto text-center" data-id="element-433">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4" data-id="element-434">
          <p className="text-5xl md:text-6xl font-serif font-bold text-terracotta" data-id="element-435">
            53 millones
          </p>
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed max-w-2xl mx-auto" data-id="element-436">
            de personas en América Latina cuidan a un familiar mayor sin apoyo
            formal. La mayoría lo hace sola. Tú no eres la excepción. Eres parte
            de una realidad que nadie nombra.
          </p>
        </motion.div>
      </div>
    </section>;
}